import Mousetrap from 'mousetrap'
import cuid from 'cuid'

class ShortcutManager

  constructor: ->
    @eventsMap = {}
    @shelf = {}
    @isPaused = false
    @pauseWhitelist = []

  getStackTrace = ->
    try
      throw new Error('')
    catch error
      stack = error.stack || ''

    stack = stack.split('\n').map((line) ->  line.trim() )
    stack.splice(if stack[0] is 'Error' then 2 else 1)

  alreadySet = (key, trace) ->
    console.error("""
      An event is already bound to the sequence: #{ key }.
      This event was bound #{ trace }.
      Please use a unique sequence per shortcut, or remember to unbind previously set events when their respective components unmount using `ShortcutManager.deregister(sequence)`.
    """)

  shelveShortcut: (key) ->
    ref = cuid()
    @shelf[ref] = {
      @eventsMap[key]...,
      sequence: key
    }
    ref

  unshelveShortcut: (ref) ->
    {
      [ref]: { sequence, fn, trace },
      rest...
    } = @shelf
    Mousetrap.bind(sequence, fn)
    @eventsMap[sequence] = { fn, trace }

  register: (key, fn, temporary = false) ->
    if _.isArray(key)
      key.map((k) => @register(k, fn, temporary))
      =>
        key.map((k) => @deregister(k, ref))
    else
      if @eventsMap[key]?
        if temporary
          ref = @shelveShortcut(key)
          Mousetrap.unbind(key)
        else
          throw alreadySet(key, @eventsMap[key].trace)
      Mousetrap.bind(key, (e) =>
        if !@isPaused or @pauseWhitelist.indexOf(key) isnt -1
          fn(e)
          e.preventDefault()
          e.stopPropagation()
      )
      # keep a trace of where the old event was set, for debugging
      @eventsMap[key] = { fn, trace: getStackTrace() }
      # return cleanup fn
      =>
        @deregister(key, ref)

  deregister: (key, shelvedRef) ->
    Mousetrap.unbind(key)
    @eventsMap = _.omit(@eventsMap, key)
    @unshelveShortcut(shelvedRef) if shelvedRef?

  pause: (whitelist = []) ->
    @isPaused = true
    @pauseWhitelist = whitelist

  unpause: ->
    @isPaused = false
    @pauseWhitelist = []

  whitelistShortcut: (args...) ->
    @pauseWhitelist = _.uniq(@pauseWhitelist.concat(args))

  blacklistShortcut: (args...) ->
    @pauseWhitelist = @pauseWhitelist.filter((sCut) -> args.indexOf(sCut) is -1)

export default new ShortcutManager()
